import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Styles from './EmbeddedVideoSection.styled';
import InView from '../Shared/InView';
import SimpleAnimation from '../../styles/Components/SimpleAnimation';
import Picture from '../Shared/Picture';
import noop from '../../util/noop';
import theme from '../../styles/theme';
import Modal from '../Shared/Modal';
import Video from '../Shared/Video';
import PlayButtonCircle from '../PlayButtonCircle';

const EmbeddedVideoSection = ({
  title = '',
  intro = '',
  disclaimer = '',
  backgroundColor = '',
  thumbnail = {},
  video = {},
  margin = {},
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handlePlayClick = handler => () => {
    setModalOpen(true);
    handler();
  };

  return (
    <InView>
      <Styles backgroundColor={backgroundColor} margin={margin}>
        {/*
          TODO
          Compress The picture/video section into a component
          that can be reused in components such as this and
          Hero videos
        */}
        <div className='inner'>
          <SimpleAnimation.div className='primary'>
            <Picture
              src={thumbnail?.src + '?w=626'}
              alt={thumbnail?.alt}
              onClick={video ? () => setModalOpen(true) : noop}
              sources={[
                {
                  media: `(min-width: ${theme.breakpoints.desktop})`,
                  params: '?w=626',
                  srcSet: thumbnail?.src,
                },
                {
                  media: `(min-width: ${theme.breakpoints.tablet})`,
                  params: '?w=512',
                  srcSet: thumbnail?.src,
                },
                {
                  media: `(max-width: ${theme.breakpoints.tablet})`,
                  params: '?w=300',
                  srcSet: thumbnail?.src,
                },
              ]}
              isResponsive
            ></Picture>
            <PlayButtonCircle
              onClick={handlePlayClick(video.onClick || noop)}
              style={{ backgroundColor: '#FFFFFFAA' }}
            />
          </SimpleAnimation.div>
          {video && modalOpen && (
            <Modal onClose={() => setModalOpen(false)}>
              <Video {...video}></Video>
            </Modal>
          )}
          <div className='secondary'>
            <SimpleAnimation.h2 delay={0.3} className='type-h2'>
              {title}
            </SimpleAnimation.h2>
            <SimpleAnimation.p delay={0.6} className='type-paragraph-default'>
              {intro}
            </SimpleAnimation.p>
          </div>
        </div>
        {disclaimer && <div className='disclaimer'>{disclaimer}</div>}
      </Styles>
    </InView>
  );
};

EmbeddedVideoSection.propTypes = {
  title: PropTypes.string,
  intro: PropTypes.string,
  backgroundColor: PropTypes.string,
  thumbnail: PropTypes.shape({
    alt: PropTypes.string,
    src: PropTypes.string,
  }),
  video: PropTypes.shape({
    source: PropTypes.oneOf(['Wistia', 'YouTube']),
    content: PropTypes.string,
  }),
  margin: PropTypes.shape({
    top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    bottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    right: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
};

export default EmbeddedVideoSection;
